import { Link, Navigate, Route, Routes } from "react-router";
import type { MeResponse } from "@hyphesync/shared";
import { Shell } from "./components/Shell";
import { Connectors } from "./pages/Connectors";
import { Gate } from "./pages/Gate";
import { Overview } from "./pages/Overview";
import { Settings } from "./pages/Settings";
import { SyncHealth } from "./pages/SyncHealth";
import { Users } from "./pages/Users";
import { canSeeSyncHealth, isAdmin } from "./lib/roles";
import { useMe } from "./lib/session";

/** Every route sits behind <Gate>: there is no public page in the dashboard. */
export function App() {
  return (
    <Gate>
      <Routes>
        <Route element={<Shell />}>
          <Route index element={<Overview />} />
          {/* The alert emails link here (lib/alerts.ts: `${APP_URL}/sync-health`). */}
          <Route path="sync-health" element={<Only when={canSeeSyncHealth}><SyncHealth /></Only>} />
          <Route path="settings" element={<Only when={isAdmin}><Settings /></Only>}>
            <Route index element={<Navigate to="users" replace />} />
            <Route path="users" element={<Users />} />
            <Route path="connectors" element={<Connectors />} />
          </Route>
          {/* Before OD-34 the Users page lived at /users. */}
          <Route path="users" element={<Navigate to="/settings/users" replace />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Gate>
  );
}

function Only({ when, children }: { when: (me: MeResponse) => boolean; children: React.ReactNode }) {
  const me = useMe();
  return when(me) ? <>{children}</> : <NotFound />;
}

function NotFound() {
  return (
    <div>
      <h1 className="font-display text-3xl font-bold tracking-tight">Page not found</h1>
      <p className="mt-2 text-muted"><Link to="/" className="font-medium text-brand underline">Back to the overview</Link></p>
    </div>
  );
}
